import {
  buildSideMenuItems,
  buildSuperAdminMenuItems,
  buildLoanAccountMenuItems,
} from "../components/SIdeMenu/menuItems";
import { getSessionRole } from "./auth";

const DETAIL_ROUTE_TITLES = [
  { prefix: "/admin/receivables/", title: "Customer ledger" },
  { prefix: "/branch/receivables/", title: "Customer ledger" },
  { prefix: "/admin/payables/", title: "Payable detail" },
  { prefix: "/branch/payables/", title: "Payable detail" },
  { prefix: "/admin/loans/", title: "Loan detail" },
  { prefix: "/branch/loans/", title: "Loan detail" },
  { prefix: "/admin/customers-payments/", title: "Customer payments" },
  { prefix: "/branch/customers-payments/", title: "Customer payments" },
  { prefix: "/admin/company-payments/", title: "Company payments" },
  { prefix: "/branch/company-payments/", title: "Company payments" },
  { prefix: "/admin/edit-customers-invoice/", title: "Edit invoice" },
  { prefix: "/branch/edit-customers-invoice/", title: "Edit invoice" },
  { prefix: "/admin/edit-customers-return/", title: "Edit return" },
  { prefix: "/branch/edit-customers-return/", title: "Edit return" },
  { prefix: "/admin/accounts/", title: "Account log" },
  { prefix: "/branch/accounts/", title: "Account log" },
];

export const getNavMenuItems = () => {
  const roleNum = getSessionRole();

  if (roleNum === 2) {
    return buildSideMenuItems("/branch", { includeReceivablesPayables: true });
  }
  if (roleNum === 0) {
    return buildSuperAdminMenuItems("/admin");
  }
  if (roleNum === 1) {
    return buildSideMenuItems("/admin", { includeReceivablesPayables: true });
  }
  if (roleNum === 4) {
    return buildLoanAccountMenuItems("/loan-account");
  }
  return [];
};

const normalizePath = (path) => {
  if (!path) return "/";
  const trimmed = path.replace(/\/+$/, "");
  return trimmed || "/";
};

export const resolveNavTitle = (pathname, items) => {
  const path = normalizePath(pathname);

  for (const route of DETAIL_ROUTE_TITLES) {
    if (path.startsWith(route.prefix) && path.length > route.prefix.length) {
      return route.title;
    }
  }

  const exact = items.find((item) => normalizePath(item.link) === path);
  if (exact) return exact.title;

  let best = null;
  for (const item of items) {
    const link = normalizePath(item.link);
    if (!link || link === "/admin" || link === "/branch" || link === "/loan-account") {
      continue;
    }
    if (path === link || path.startsWith(`${link}/`)) {
      if (!best || link.length > normalizePath(best.link).length) best = item;
    }
  }

  if (best) return best.title;
  if (path === "/admin" || path === "/branch" || path === "/loan-account") {
    return "Dashboard";
  }
  return "Menu";
};

export const normalizeNavPath = normalizePath;
